export enum DeliveryOptions {
  ECard = 'Ecard',
  PDF = 'PDF',
}
